import { createContext } from 'react';
import { TranslationKeyEnum } from '../types/constants';

// Define the context type
export type TranslationContextType = {
  locale: string;
  t: (key: TranslationKeyEnum, ...args: string[]) => string;
  formatCurrency: (value: number) => string;
  formatNumber: (value: number) => string;
  formatDate: (dateString: string) => string;
  formatDateMonthYear: (dateString: string) => string;
  formatMonthDateYear: (dateString: string) => string;
};

// Create context with default values
export const TranslationContext = createContext<TranslationContextType>({
  locale: 'en-US',
  t: (key) => String(key),
  formatCurrency: (value) => `$${value}`,
  formatNumber: (value) => String(value),
  formatDate: (dateString) => dateString,
  formatDateMonthYear: (dateString) => dateString,
  formatMonthDateYear: (dateString) => dateString,
});
